import { isMobile } from '@/utils';
import Tracker from './tracker';

/**
 * @desc 以旧换新埋点
 * @param {string} action 事件操作
 * @param {object} label 事件标签
 */
class TradeUpTracker extends Tracker {
  /**
   * @param action 事件操作   click_brand选择想要买什么设备 / click_brand_device 用户手上的设备品牌
   */
  tradeUpPage = ({ action, label }) => {
    try {
      this.commonTracker({
        category: `${isMobile() ? 'mobile' : 'pc'}_Tradeup`,
        action,
        label,
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   * @param action 事件操作   click_品牌型号
   */
  tradeUpDevice = ({ action }) => {
    try {
      this.commonTracker({
        category: 'Tradeup',
        action,
      });
    } catch (e) {
      console.log(e);
    }
  };
}

const T = new TradeUpTracker();
export default T;
